<template>
  <div>
    <div class="navbar">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>

      <breadcrumb></breadcrumb>

      <div class="header_bell" @click="openApplyRecordPage">
        <el-tooltip
          effect="dark"
          placement="bottom"
          :content="`待审批 ${waitCount} · 抄送未读 ${copyCount}`"
          :disabled="ReadCount === 0"
        >
          <el-badge :value="ReadCount" :hidden="ReadCount === 0" class="item">
            <i class="el-icon-bell" style="font-size: 30px"></i>
          </el-badge>
        </el-tooltip>
      </div>

      <el-dropdown
        class="avatar-container"
        trigger="click"
        placement="bottom-end"
        :append-to-body="true"
        popper-class="navbar-user-dropdown"
        @command="handleAvatarCommand"
      >
        <span class="avatar-dropdown-trigger">
          <span class="avatar-dropdown-name">欢迎您，{{ name }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item disabled>
            <span>部门：{{ departmentName }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided command="editPwd">修改密码</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- <div class="header2">
      <div class="left">客服管理</div>
      <div class="right">
        <div>账号：<span>{{ name }}</span></div>
        <div>部门：<span>客服</span></div>
      </div>
    </div> -->

    <div>
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible" @close="closeFrom">
        <el-form :model="ruleForm" status-icon label-width="130px" width="50%" ref="ruleForm" class="demo-ruleForm"
                 :rules="rules">
          <el-form-item label="当前密码" prop="oldpassword">
            <el-input type="password" v-model="ruleForm.oldpassword" autocomplete="off" class="left2" maxlength="20"
                      minlength="6">
            </el-input>
          </el-form-item>
          <el-form-item label="修改密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" class="left2" maxlength="20"
                      minlength="6"></el-input>
          </el-form-item>
          <el-form-item label="二次密码" prop="confirmpassword">
            <el-input type="password" v-model="ruleForm.confirmpassword" autocomplete="off"
                      style="width: 320px;" maxlength="20" minlength="6"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button @click="closeFrom">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import {
  fetchWaitExamineCount,
  subscribeWaitExamineCount,
  startWaitExamineCountPoll,
  stopWaitExamineCountPoll,
  resetWaitExamineCount,
} from '@/utils/waitExamineCount';


export default {
  data() {
    var validatejPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        if (this.ruleForm.oldpassword !== "") {
          this.$refs.ruleForm.validateField("oldpassword");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || value.length < 6) {
        callback(new Error("请输入密码不能小于6位"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,  //修改密码弹窗
      name: "",
      departmentId: '',
      departmentName: '',

      ruleForm: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },

      ReadCount: 0,
      waitCount: 0,
      copyCount: 0,
      _unsubWaitCount: null,
      ypid1: "30",
      ypid2: "27",
      ypid3: "28",
      ypid4: "26",


      rules: {
        oldpassword: [
          {required: true, message: '旧密码不能为空', trigger: "blur"},
          {
            required: true,
            pattern: /^[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母组合", trigger: ["change", "blur"]
          },
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: "blur"},
          {
            required: true,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母组合", trigger: ["change", "blur"]
          },
        ],
        confirmpassword: [
          {required: true, validator: validatePass2, trigger: "blur"},
        ],
      },

    };
  },
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  beforeDestroy() {
    if (this._unsubWaitCount) {
      this._unsubWaitCount()
      this._unsubWaitCount = null
    }
    stopWaitExamineCountPoll()
  },

  created() {
    this._unsubWaitCount = subscribeWaitExamineCount(({ waitCount, copyCount }) => {
      this.waitCount = waitCount
      this.copyCount = copyCount
      this.ReadCount = waitCount + copyCount
    })
    startWaitExamineCountPoll()
    this.name = localStorage.getItem("realname") ? localStorage.getItem("realname") : "";

    this.departmentId = localStorage.getItem("departmentId") ? localStorage.getItem("departmentId") : "";

    this.ruleForm.id = localStorage.getItem("id");
    this.ruleForm.username = localStorage.getItem("username");

    //部门
    this.$api.get("/sys/department/getSelect").then((res) => {
      if ((res.data.success = true)) {
        res.data.result.forEach(item => {
          if (this.departmentId == item.id) {
            this.departmentName = item.departmentName;
          }
        })
      }
    });
  },
  methods: {
    openApplyRecordPage() {
      const applyPath = '/approval/approvalList';
      if (this.$route.path === applyPath || this.$route.name === 'approvalList') {
        this.$message.info('已在审批列表');
      } else {
        localStorage.setItem('isNoRead', '1');
        this.$router.push({
          name: 'approvalList',
          params: { ypid3: localStorage.getItem('Menuids') }
        });
      }
      fetchWaitExamineCount({ force: true });
    },
    getReadCount() {
      return fetchWaitExamineCount();
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    //修改密码
    editPwd() {
      this.dialogFormVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let obj = {
            username: this.ruleForm.username,
            oldpassword: this.ruleForm.oldpassword,
            password: this.ruleForm.password,
            confirmpassword: this.ruleForm.confirmpassword,

          };
          this.$api.put("/sys/user/updatePassword", obj, true).then((res) => {
            if (res.data.success == true) {
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
              this.closeFrom()
              resetWaitExamineCount();

              // 清空localStorage缓存
              const urlcode = localStorage.getItem('urlcode'); // 保留urlcode配置
              localStorage.clear();
              if (urlcode) {
                localStorage.setItem('urlcode', urlcode); // 恢复urlcode
              }
              
              // 清空sessionStorage缓存
              sessionStorage.clear();
              
              // 清空Vuex store状态
              this.$store.commit('SET_TOKEN', '');
              this.$store.commit('SET_ROLES', []);
              this.$store.commit('SET_NAME', '');
              this.$store.commit('SET_AVATAR', '');
              
              // 跳转到登录页
              this.$router.push({path: "/login"});
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.ruleForm.oldpassword = '';
      this.ruleForm.password = '';
      this.ruleForm.confirmpassword = '';
    },

    closeFrom() {
      this.ruleForm.oldpassword = '';
      this.ruleForm.password = '';
      this.ruleForm.confirmpassword = '';
      this.dialogFormVisible = false
    },

    // 注销
    logout() {
      this.$confirm("真的要退出登录吗 ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        resetWaitExamineCount();

        // 清空localStorage缓存
        const urlcode = localStorage.getItem('urlcode'); // 保留urlcode配置
        localStorage.clear();
        if (urlcode) {
          localStorage.setItem('urlcode', urlcode); // 恢复urlcode
        }
        
        // 清空sessionStorage缓存
        sessionStorage.clear();
        
        // 清空Vuex store状态
        this.$store.commit('SET_TOKEN', '');
        this.$store.commit('SET_ROLES', []);
        this.$store.commit('SET_NAME', '');
        this.$store.commit('SET_AVATAR', '');
        
        // 跳转到登录页
        this.$router.push({path: "/login"});
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //跳转界面
    compile(i) {
      if (i == 1) {
        this.$router.push({
          name: "PersonalInformationManagement",
          params: {ypid1: this.ypid1},
        });
      } else if (i == 2) {
        this.$router.push({
          name: "MyTasks",
          params: {ypid2: this.ypid2},
        });
      } else if (i == 3) {
        this.$router.push({
          name: "PatientInformationManagement",
          params: {ypid3: this.ypid3},
        });
      } else if (i == 4) {
        this.$router.push({
          name: "PatientInformationInput",
          params: {ypid4: this.ypid4},
        });
      }
    },

    handleAvatarCommand(command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'editPwd') {
        this.editPwd()
      }
    },

  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 55px;
  line-height: 55px;
  border-radius: 0 !important;
  display: flex;
  align-items: center;
  position: relative;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* 右侧留出空间给绝对定位的铃铛(~10vw) + 用户名(~160px) */
  padding: 0 220px 0 20px;
  overflow: visible;
  min-width: 0;
  /* 确保导航栏始终在移动端遮罩层（z-index:1000）之上，hamburger 可点击 */
  z-index: 1002;

  .hamburger-container {
    flex-shrink: 0;
    padding: 0 10px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #667eea;
    }
  }
}

/* 面包屑允许收缩，避免在窄屏撑宽 navbar */
::v-deep .el-breadcrumb {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.avatar-container {
  height: 50px;
  display: inline-block;
  position: absolute;
  right: 35px;
  top: 0;
  z-index: 1010;
  font-size: 14px;
  color: #2c3e50;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    color: #667eea;
  }

  .avatar-dropdown-trigger {
    display: inline-flex;
    align-items: center;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    user-select: none;
    outline: none;
  }

  .avatar-dropdown-name {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .avatar-wrapper {
    cursor: pointer;
    margin-top: 5px;
    position: relative;

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid #667eea;
    }

    .el-icon-caret-bottom {
      position: absolute;
      right: -20px;
      top: 25px;
      font-size: 12px;
    }
  }
}

.header {
  display: flex;
  position: absolute;
  right: 200px;
  height: 80px;
  line-height: 80px;
}

.header .topTitle {
  margin: 0 15px;
  text-align: center;
  width: 80px;
}

.header .topTitle img {
  width: 50px;
  height: 30px;
}

.header .topTitle .title {
  margin-top: -60px;
}

.header2 {
  height: 50px;
  display: flex;
  line-height: 50px;
}

.header2 .left {
  background-color: aqua;
  width: 10%;
  text-align: center;
}

.header2 .right {
  width: 90%;
  background-color: beige;
  display: flex;
  justify-content: end;
  padding-right: 220px;
}

.header2 .right div:nth-child(1) {
  margin-right: 55px;
}

.left1 {
  margin-bottom: 10px;
}

.left2 {
  width: 100%;
  max-width: 320px;
}

.header_bell {
  position: absolute;
  right: 200px;
  top: 0;
  height: 55px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 1005;
}

.item {
  margin-top: 10px;
  margin-right: 10px;
}

/* ─── 移动端顶栏适配 ─── */
@media screen and (max-width: 768px) {
  .navbar {
    /* 小屏右侧只需留出铃铛(40px)+用户区(90px)+间距 */
    padding: 0 140px 0 8px;
  }

  /* 移动端铃铛紧贴右侧 */
  .header_bell {
    right: 88px;
  }

  /* 用户名区右侧 */
  .avatar-container {
    right: 12px;
    font-size: 13px;
  }

  .avatar-dropdown-name {
    max-width: 72px;
  }

  /* 面包屑在移动端缩小字号 */
  ::v-deep .el-breadcrumb {
    font-size: 12px;
  }

  /* 铃铛图标缩小 */
  .header_bell .el-icon-bell {
    font-size: 22px !important;
  }
}

// 弹窗样式优化
::v-deep .el-dialog {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

::v-deep .el-dialog__header {
  padding: 20px 25px;
  border-bottom: 1px solid #ebeef5;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px 12px 0 0;
  
  .el-dialog__title {
    color: #ffffff;
    font-weight: 600;
    font-size: 18px;
  }
}

::v-deep .el-dialog__body {
  padding: 30px 25px;
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #2c3e50;
}

::v-deep .el-input__inner {
  border-radius: 8px;
  transition: all 0.3s;
  
  &:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
  }
}

::v-deep .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
}

::v-deep .el-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  padding: 8px 0;
}

::v-deep .el-dropdown-menu__item {
  padding: 12px 20px;
  transition: all 0.3s;
  
  &:hover {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    color: #667eea;
  }
}

</style>

<style lang="scss">
/* 下拉挂到 body，需全局样式保证层级与可点击 */
.navbar-user-dropdown {
  z-index: 3000 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue